import React, { useState } from 'react';
import { experimentalStyled as styled } from '@material-ui/core/styles';

const ButtonWrapper = styled('a')(({ theme, $shouldExpand }) => ({
  position: 'fixed',
  right: 24,
  bottom: 12,
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row-reverse',
  width: $shouldExpand ? 124 : 46,
  height: 46,
  borderRadius: 50,
  textDecoration: 'none',
  color: '#FFFFFF',
  fontFamily: theme.typography.fontFamily || 'Inter, sans-serif',
  fontSize: '0.875rem',
  fontWeight: 600,
  letterSpacing: '0.3px',
  background: 'linear-gradient(135deg, #0072FF 0%, #00C6FF 100%)',
  boxShadow: $shouldExpand
    ? '0 12px 28px rgba(0, 114, 255, 0.5)'
    : '0 8px 20px rgba(0, 114, 255, 0.35)',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  transition: 'width 0.35s cubic-bezier(0.4, 0, 0.2, 1), transform 0.35s, box-shadow 0.35s',
  cursor: 'pointer',
  userSelect: 'none',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  transform: $shouldExpand ? 'translateY(-4px)' : 'none',
  animation: 'fadeIn 0.5s ease-out both',

  '& svg': {
    flexShrink: 0,
    transition: 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
    transform: $shouldExpand ? 'rotate(12deg) scale(1.05)' : 'none'
  },

  '& .support-text': {
    opacity: $shouldExpand ? 1 : 0,
    maxWidth: $shouldExpand ? 70 : 0,
    marginRight: $shouldExpand ? 8 : 0,
    overflow: 'hidden',
    transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
    display: 'inline-block'
  },

  '@keyframes fadeIn': {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 }
  },

  [theme.breakpoints.down('sm')]: {
    right: 16,
    bottom: 8
  }
}));

export default function SupportButton() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <ButtonWrapper
      id="support-button"
      href="https://support.skywhoo.com/dashboard"
      target="_blank"
      rel="noopener noreferrer"
      $shouldExpand={isHovered}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
        <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
      </svg>
      <span className="support-text">Support</span>
    </ButtonWrapper>
  );
}
